import http from "./HttpService";
import { getJwt } from "./Admin/AuthService";
import { API_BASE_URL_ENV } from "../helpers/common";

const apiDropdownEndpoint = API_BASE_URL_ENV() + "/admin/settings/dropdown";
const apiUploadEndpoint = API_BASE_URL_ENV() + "/files/uploadFile";
const apiUploadOtherEndpoint = API_BASE_URL_ENV() + "/common/upload";

export default class BaseService {
	apiEndpoint;

	constructor(apiEndPoint) {
		http.setJwt(getJwt());
		this.apiEndpoint = apiEndPoint;
	}

	entityUrl(params = []) {
		return `${this.apiEndpoint}/${params.join("/")}`;
	}

	dropDownUrl(model) {
		return `${apiDropdownEndpoint}/${model}`;
	}

	getList(params) {
		return http.get(this.apiEndpoint, { params });
	}

	find(id, params) {
		return http.get(this.entityUrl([id]), { params });
	}

	create(data) {
		return http.post(this.apiEndpoint, data);
	}

	update(id, data) {
		const body = { ...data };
		return http.put(this.entityUrl([id]), body);
	}

	toggleStatus(model, id, params = []) {
		return http.get(this.entityUrl(["toggle-activation", model, id]), {
			params,
		});
	}

	getDropDown(model, params = []) {
		return http.get(this.dropDownUrl(model), { params });
	}

	remove(id) {
		return http.delete(this.entityUrl([id]));
	}

	postUpload(selectedFile) {
		const formData = new FormData();
		formData.append("img", selectedFile);
		return http.post(apiUploadEndpoint, formData, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
	}
	postUploadOther(selectedFile, options) {
		const formData = new FormData();
		formData.append("selectedFile", selectedFile);
		return http.post(apiUploadOtherEndpoint, formData, options);
	}
	getInstallmentRecurringPayment(options, type) {
		const url =
			API_BASE_URL_ENV() + `/${type}/resale/installment-recurring-payment`;
		return http.post(url, options);
	}
	getOwnerInstallmentRecurringPayment(options, type) {
		const url =
			API_BASE_URL_ENV() +
			`/${type}/resale/owner-installment-recurring-payment`;
		return http.post(url, options);
	}
	getOffPayment(options, type) {
		const url =
			API_BASE_URL_ENV() + `/${type}/resale/owner-installment-off-payment`;
		return http.post(url, options);
	}

	changeStatus(id, type) {
		return http.get(
			`${API_BASE_URL_ENV()}/admin/settings/toggle-activation/${type}/${id}`
		);
	}
}
